// extracted by mini-css-extract-plugin
export var button = "newsletter-module--button--bde9e";
export var checkboxConsent = "newsletter-module--checkbox-consent--4908a";
export var checkboxSubscription = "newsletter-module--checkbox-subscription--db33f";
export var consents = "newsletter-module--consents--f0d89";
export var form = "newsletter-module--form--800cd";
export var rodoNote = "newsletter-module--rodo-note--313c0";
export var title = "newsletter-module--title--cb95c";